import React from 'react';
import './status-indicator.scss';

const StatusIndicator = ({ isActive }) =>
    isActive ? null : <div className="status-indicator inactive">Inactive</div>;

export default StatusIndicator;